import { useState, useEffect } from 'react';
import Questions from '../components/questions';
import Menu from '../components/menu';
import { IQuestion } from '../data/interfaces';

type Props = {
  category: string;
  questions: IQuestion[];
};

export default ({ category, questions }: Props) => {
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    switch (category) {
      case 'language':
        setPageTitle('Georgian Language');
        break;
      case 'history':
        setPageTitle('History of Georgia');
        break;
      case 'law':
        setPageTitle('Fundamentals of Law');
        break;
      default:
        break;
    }
  }, [category]);

  return (
    <div>
      <Menu isSimulation={false} pageTitle={pageTitle} />
      <div className="main">
        <div className="main-content">
          <Questions questions={questions} category="all" hasAnswer />
        </div>
      </div>
    </div>
  );
};
